import { Feature, GeoJSON, Polygon } from "geojson";
import { cloneDeep } from "lodash";

function removePolygonHeights(geoJson: GeoJSON): Feature<Polygon> {
  const resultGeoJson: GeoJSON = cloneDeep(geoJson);
  if (
    resultGeoJson.type !== "Feature" ||
    resultGeoJson.geometry.type !== "Polygon"
  ) {
    throw new Error("GeoJson is not single feature polygon");
  }

  resultGeoJson.geometry.coordinates = resultGeoJson.geometry.coordinates.map(
    (linearRing) => linearRing.map((coordinate) => coordinate.slice(0, 2)),
  );

  return resultGeoJson as Feature<Polygon>;
}

export default removePolygonHeights;
